var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { class: { light: _vm.light } },
    [
      _c(
        "w-col",
        { class: { light: _vm.light }, attrs: { xs: "12", md: "6" } },
        [
          _c("w-input-autocomplete", {
            attrs: {
              value: _vm.mainGroup,
              fancy: "",
              up: "",
              "auto-up": false,
              label: _vm.$ct("root-group"),
              items: _vm.fetchedParentGroups,
              "input-delay": 100,
            },
            on: {
              input: function ($event) {
                return _vm.onMainGroupInput($event)
              },
              "item-click": function ($event) {
                return _vm.onMainGroupInput($event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (g) {
                  return [_vm._v(" " + _vm._s(g.item) + " ")]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-row",
            {
              class: { "sub-group-col": !_vm.light },
              attrs: { "no-margin": "" },
            },
            [
              _c("w-input-autocomplete", {
                class: { mr: !_vm.light },
                style: { flexGrow: 1 },
                attrs: {
                  value: _vm.subGroup,
                  fancy: "",
                  "auto-up": false,
                  up: "",
                  label: _vm.$ct("sub-group"),
                  items: _vm.fetchedSubGroups,
                  "input-delay": 100,
                },
                on: {
                  input: function ($event) {
                    return _vm.onSubGroupInput($event)
                  },
                  "item-click": function ($event) {
                    return _vm.onSubGroupInput($event)
                  },
                  focus: function ($event) {
                    return _vm.fetchSubGroups()
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (g) {
                      return [_vm._v(" " + _vm._s(g.item) + " ")]
                    },
                  },
                ]),
              }),
              !_vm.light
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("clear-group"),
                          expression: "$ct('clear-group')",
                        },
                      ],
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.clearGroup()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }